<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center">
      {{ this.$string.sidebar.menu_7.sub_menu.menu_3 }}
      <CButton color="danger" style="float:right;margin-right:10px" class="btn-md ml-auto">Ekspor PDF</CButton>
      <CDropdown
        toggler-text="Ekspor Excel"
        color="warning"
        class="mr-2 d-inline-block text-white float-right"
      >
        <CDropdownItem>Ekspor Semua</CDropdownItem>
        <CDropdownItem>Ekspor Beberapa Data</CDropdownItem>
      </CDropdown>
      <CButton
        color="success"
        style="float:right;margin-right:10px"
        class="btn-md"
        @click="myModal = true"
      >Tambah</CButton>
    </CCardHeader>
    <!-- Data Broadcast -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id>
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option>Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" name id class="form-control" placeholder="Cari Data ..." />
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol sm="6" lg="12">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{item}">
              <td class="py-2">{{ item.no }}</td>
            </template>
            <template #_orders="{item}">
              <td class="py-2 text-center">
                <i class="fa fa-check text-success" aria-hidden="true" v-if="item._orders == 1"></i>
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center d-flex align-items-center">
                <CButton color="success" class="btn-sm text-white mr-1" square>
                  <font-awesome-icon icon="eye" />
                </CButton>&nbsp;&nbsp;
                <CButton color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
        size="md"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <div class="form-group">
                <label for class="font-weight-bold">Tujuan</label>
                <select class="form-control">
                  <option value>Pilih Tujuan</option>
                  <option value="semua">Semua Anggota</option>
                  <option value="akuntan-publik">Akuntan Publik</option>
                  <option value="kantor-akuntan">Kantor Akuntan Publik</option>
                </select>
              </div>
            </CCol>
            <CCol sm="12">
              <div class="form-row">
                <div class="col-12">
                  <label for class="font-weight-bold">Daftar Tujuan</label>
                </div>
                <div class="col-12">
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="all" name />
                    <label class="custom-control-label font-weight-bold" for="all">Ceklis Semua</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check1" name />
                    <label class="custom-control-label" for="check1">Andra</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check2" name />
                    <label class="custom-control-label" for="check2">Andri</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check3" name />
                    <label class="custom-control-label" for="check3">Bimo</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check4" name />
                    <label class="custom-control-label" for="check4">Bima</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check5" name />
                    <label class="custom-control-label" for="check5">Caca</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check6" name />
                    <label class="custom-control-label" for="check6">Cendri</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check7" name />
                    <label class="custom-control-label" for="check7">Doni</label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check8" name />
                    <label class="custom-control-label" for="check8">Eka</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check9" name />
                    <label class="custom-control-label" for="check9">Eki</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check10" name />
                    <label class="custom-control-label" for="check10">Eki</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check11" name />
                    <label class="custom-control-label" for="check11">Eko</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check12" name />
                    <label class="custom-control-label" for="check12">Farah</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-3">
                    <input type="checkbox" class="custom-control-input" id="check13" name />
                    <label class="custom-control-label" for="check13">Fera</label>
                  </div>
                </div>
              </div>
            </CCol>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Subjek" placeholder="Masukkan Subjek" />
            </CCol>
            <CCol sm="12">
              <CTextarea
                rows="3"
                class="font-weight-bold"
                label="Pesan"
                placeholder="Masukkan Isi Pesan"
              />
            </CCol>
            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <div class="custom-file text-truncate">
                <input type="file" class="custom-file-input" id="validatedCustomFile" />
                <label
                  class="custom-file-label"
                  data-browse="Pilih File"
                  for="validatedCustomFile"
                >{{ fileName }}.</label>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah</h6>          
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data Broadcast -->
  </CCard>
</template>
<script>
const items = [
  {
    no: "1",
    tujuan: "Semua Anggota (Tertunda)",
    subjek: "CPA Pemegang Izin AP",
    isi_pesan:
      "Jakarta, CNN Indonesia -- Institut Akuntan Publik Indonesia (IAPI) mengaku sedang menelaah metode audit laporan keuangan tahun 2018 milik PT Garuda Indonesia (Persero) Tbk. Melalui langkah ini, IAPI ingin memastikan bahwa akuntan yang berada di bawah naungannya benar- benar mematuhi kode etik dan Standar Profesional Akuntan Publik (SPAP).",
    file: "",
    tgl_kirim: "Senin, 20 Januari 2020 (Admin IAPI)",
    jmlh_email: "15 Email",
    _orders: 1
  },
  {
    no: "2",
    tujuan: "Akuntan Publik",
    subjek: "CPA Pemegang Izin AP",
    isi_pesan:
      "Jakarta, CNN Indonesia -- Institut Akuntan Publik Indonesia (IAPI) mengaku sedang menelaah metode audit laporan keuangan tahun 2018 milik PT Garuda Indonesia (Persero) Tbk. Melalui langkah ini, IAPI ingin memastikan bahwa akuntan yang berada di bawah naungannya benar- benar mematuhi kode etik dan Standar Profesional Akuntan Publik (SPAP).",
    file: "",
    tgl_kirim: "Senin, 20 Januari 2020 (Admin IAPI)",
    jmlh_email: "15 Email",
    _orders: 1
  }
];

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "tujuan",
    label: "Tujuan",
    sorter: true,
    filter: false
  },
  {
    key: "isi_pesan",
    label: "Isi Pesan",
    _style: "width: 30%",
    sorter: true,
    filter: false
  },
  {
    key: "file",
    label: "File",
    sorter: true,
    filter: false
  },
  {
    key: "tgl_kirim",
    label: "Tanggal Pengiriman",
    sorter: true,
    filter: false
  },
  {
    key: "jmlh_email",
    label: "Jumlah Email",
    sorter: true,
    filter: false
  },  
  {
    key: "_orders",
    label: "Pesanan",
    sorter: false,
    filter: false,
    _style: "text-align: center"
  },
  {
    key: "aksi",
    _style: "width: 12%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Data Peserta",
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  methods: {
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    }
  }
};
</script>